// This is the actual entrypoint for the frontend code when running the
// miacademy theme on mohs.miaprep.school.
// This provides all the JavaScript and CSS assets for the frontend, except for
// some very old CSS legacy that is handled by the CssStyleCollector and some
// JavaScript assets that are bundled by gulp.
import "@/../SASS/miacademy/legacy.scss";
import { mountMainVueApplication } from "@/entrypoint";

mountMainVueApplication();
